import { render } from "./Change.vue?vue&type=template&id=46166791&scoped=true"
import script from "./Change.vue?vue&type=script&lang=js"
export * from "./Change.vue?vue&type=script&lang=js"

import "./Change.vue?vue&type=style&index=0&id=46166791&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-46166791"

export default script